/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useState, useRef, useContext } from "react";
import { IconButton, Paper } from "@mui/material";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import LabelledField from "components/labelled-field";
import { useClickAway } from "hooks/useClickAway";
import { ModalDialog } from "cms/documents/document-selector/display/modal-dialog";
import { useTheme } from "@mui/material/styles";
import { formatBytes } from "utils/format-bytes";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { objectHasPropertyString } from "utils/empty-exists";

const DocumentInfoCard = () => {

    const { document } = useContext(DocumentEditContext);

    const theme = useTheme();
    const [info, setInfo] = useState(false);
    const buttonStyle = { color: theme.palette.grey["400"] };
    const wrapperRef = useRef();
    const infoButtonRef = useRef();

    const openInfo = async () => {
        if (!info) {
            setInfo(true);
        } else {
            setInfo(false);
        }
    };
    const closeInfo = async () => {
        setInfo(false);
    };
    useClickAway(wrapperRef, closeInfo);

    return (
        <Fragment>
            {objectHasPropertyString(document,"url") &&
                <>
                    <div className='document-info'>
                        <IconButton
                            ref={infoButtonRef}
                            style={buttonStyle}
                            aria-label='upload document'
                            component='span'
                            onClick={openInfo}
                        >
                            <InfoOutlinedIcon />
                        </IconButton>
                    </div>

                    <div ref={wrapperRef}>
                        {info && (
                            <ModalDialog
                                classToUse='modal link-info-box-modal'
                                infoButtonRef={infoButtonRef}
                                aria-labelledby='modal-modal-title'
                                aria-describedby='modal-modal-description'
                            >
                                <Paper elevation={3} className='document-info-box'>
                                    <LabelledField label='Title' variant='subtitle1'>
                                        <span className='info-text'>{document.title}</span>
                                    </LabelledField>
                                    <LabelledField label='File Type' variant='subtitle1'>
                                        <span className='info-text'>{document.file_type}</span>
                                    </LabelledField>
                                    <LabelledField label='File Size' variant='subtitle1'>
                                        <span className='info-text'>{formatBytes(document.file_size)}</span>
                                    </LabelledField>
                                </Paper>
                            </ModalDialog>
                        )}
                    </div>
                </>
            }
        </Fragment>
    );
};

export { DocumentInfoCard };
